import React, { useCallback } from 'react';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import { KeyRootAPI, toUnicodeKeyRoot } from 'types/enums';
import ActiveFilter from '../components/ActiveFilter';
import { TagItem } from '../styled';

const getActiveKey = (
    root: string | null,
    removeFilter: (modifiers: ModifiersPayload[]) => void,
) => {
    const normalizedFilter = toUnicodeKeyRoot(root as KeyRootAPI);

    const onClear = useCallback(() => {
        removeFilter([[FiltersParams.keyrootnote, root]]);
    }, [root]);

    if (!root) {
        return null;
    }

    return (
        <TagItem
            key={`filter-${FiltersParams.keyrootnote}-${normalizedFilter}`}
        >
            <ActiveFilter onClick={onClear} filter={normalizedFilter} />
        </TagItem>
    );
};

export default getActiveKey;
